
import { localStorageConfigs } from '../../configs/localStorageConfigs';


export const LOCAL_STORAGE_SETTINGS_KEY = 'hyperDashboardSettings';

const getValueByPropName = (propName, defaultValue = undefined) => {

    const output = (settings => settings ? settings[propName] && settings[propName].value : null)(JSON.parse(localStorage.getItem(LOCAL_STORAGE_SETTINGS_KEY)));

    return output ? output : defaultValue;
};

const setValueByPropName = (propName, value) => {

    let currentSettings = JSON.parse(localStorage.getItem(LOCAL_STORAGE_SETTINGS_KEY));

    if(propName in currentSettings) {
        currentSettings = {
            ...currentSettings,
            [propName]: {
                ...currentSettings[propName],
                value
            }
        };
    }

    localStorage.setItem(LOCAL_STORAGE_SETTINGS_KEY, JSON.stringify(currentSettings));
};

const setInitialSettings = () =>
    localStorage.setItem(LOCAL_STORAGE_SETTINGS_KEY, JSON.stringify(localStorageConfigs));

const settings = (settings => typeof settings === 'object' ? settings : {})(JSON.parse(localStorage.getItem(LOCAL_STORAGE_SETTINGS_KEY)));

const checkIfAllPropsInSettings = () => {
    return Object.keys(localStorageConfigs).length === (settings && Object.keys(settings).length);
};

export const localStorageHyperDashboardTools = {
    checkIfAllPropsInSettings,
    getValueByPropName,
    setValueByPropName,
    setInitialSettings,
    settings
};
